"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T = void 0;
var _i18nRuntime = require("@vimeo/i18n-runtime");
var T = exports.T = {
  daily: (0, _i18nRuntime.translate)('Daily'),
  notStartedYet: (0, _i18nRuntime.translate)('This live event has not started yet'),
  scheduled: (0, _i18nRuntime.translate)('Scheduled'),
  schedulePlaceholder: (0, _i18nRuntime.translate)('This event hasn\'t started yet'),
  watchLive: (0, _i18nRuntime.translate)('Watch live'),
  weekdays: (0, _i18nRuntime.translate)('Weekdays'),
  weekends: (0, _i18nRuntime.translate)('Weekends')
};